import React, {FC, memo} from 'react';
import styled from 'styled-components';

import {TeamModel} from '../../../../../../libs/shared/core/src/models/api/teamModel';
import {TeamAvatar} from '../../../../../../libs/shared/ui/src/components/avatar/teamAvatar';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface CellTeamProps {
  team: TeamModel;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  grid-area: bottom-right;
`;

/*
 * Component.
 */

export const CellTeam: FC<CellTeamProps> = memo((props) => (
  <StyledWrapperDiv>
    <TeamAvatar team={props.team} size={VisualSizesEnum.SMALL} />
  </StyledWrapperDiv>
));
